jQuery(function ($){

  openMenu(
    $('.menu-btn'),
    $('.main-menu'),
    $('.main-menu__close')
  )

  function openMenu (openBtn, menu, closeBtn) {

    openBtn.on('click', function() {

      menu.removeClass('disable');

    });

    closeBtn.on('click', function() {

      menu.addClass('disable');

    });

  }

});
